import React from "react";
import './Spinner.css'


const Spinner = () => {
    return (
        <div style={{ minHeight: '133px', position: "relative" }}>
            <div className="loading">
                <div className='uil-ring-css' style={{ transform: 'scale(0.79)' }}>
                    <div></div>
                </div>
            </div>
        </div>
    );
}

export default Spinner;